import styled from "styled-components";

const StyledCellJustification = styled.td`
    & > textarea {
        resize: none;
        width: 100%;
        height: 78px;
        border: none;
        overflow: auto;
        outline: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        background: transparent;
    }
`;

const StyledPaginationContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 70px;
    padding-right: 5px;
`;

export default { StyledCellJustification, StyledPaginationContainer };
